import React, { useEffect, useRef } from "react";
import { prepareEmailPreviewDocument } from "./emailHtmlUtils";

type Props = {
  html: string;
  title?: string;
  className?: string;
};

export const EmailHtmlPreview = ({
  html,
  title = "Email preview",
  className,
}: Props) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return undefined;

    const doc = prepareEmailPreviewDocument(html);

    const render = () => {
      const idoc = iframe.contentDocument;
      if (!idoc) return;
      idoc.open();
      idoc.write(doc);
      idoc.close();

      const resize = () => {
        const body = idoc.body;
        const htmlEl = idoc.documentElement;
        if (!body || !htmlEl) return;
        const height = Math.max(
          body.scrollHeight,
          body.offsetHeight,
          htmlEl.clientHeight,
          htmlEl.scrollHeight,
          htmlEl.offsetHeight
        );
        iframe.style.height = `${Math.max(height, 480)}px`;
      };

      resize();
      window.setTimeout(resize, 100);
      window.setTimeout(resize, 400);
    };

    iframe.onload = render;
    render();

    return () => {
      iframe.onload = null;
    };
  }, [html]);

  return (
    <div className="email-mkt__composer-preview-shell">
      <iframe
        ref={iframeRef}
        title={title}
        className={
          className ||
          "email-mkt__composer-preview email-mkt__composer-preview--full email-mkt__composer-preview--frame"
        }
      />
    </div>
  );
};
